import { useHistory } from "react-router";

import { PaintBucket } from "@/components/icons/svg/figma/PaintBucket";
import { Button } from "@/design-system/components/Button/Button";

export const ErrorPage = () => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push("/");
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <div className="mt-20 flex items-center justify-center">
      <div className="mx-auto flex max-w-md flex-col gap-8 text-center">
        <div className="flex justify-center">
          <PaintBucket className="h-28" />
        </div>

        <div className="flex flex-col gap-4">
          <h1 className="text-6xl font-bold">404</h1>
          <h2 className="text-2xl font-semibold">Page Not Found</h2>
          <p>
            The page you are looking for doesn't exist or has been moved. Please
            check the URL or navigate back to continue.
          </p>
        </div>

        <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
          <Button onClick={handleGoHome} className="w-full sm:w-auto">
            Go Home
          </Button>
          <Button
            onClick={handleGoBack}
            variant="secondary"
            className="w-full sm:w-auto"
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};
